import React, { useState, useEffect } from 'react'
import { Form, InputGroup, Col, Button, Accordion, Card, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from "@hookform/error-message";
import $ from "jquery";
import CustomSpinner from '../../generic/CustomSpinner';

const AddDestinoHermana = ({ provincias, handleForm, edicion = {} }) => {
  //console.log({ 'edicion': edicion })

  useEffect(() => {
    if (edicion.provinceId) {
      handleObtenerComunidades(null, edicion.provinceId)
    }
  }, [])

  const [comunidades, setComunidades] = useState()
  const [loading, setLoading] = useState(false);

  const { register, getValues, formState: { errors }, handleSubmit } = useForm({
    defaultValues: {
      startDate: edicion.startDate ? edicion.startDate : null,
      endDate: edicion.endDate ? edicion.endDate : null,
      provinceId: edicion.provinceId ? edicion.provinceId : null,
      communityId: edicion.communityId ? edicion.communityId : null,
      id: edicion.id ? edicion.id : null
    },
  })

  const onSubmit = (data) => {
    if (data.endDate === '') {
      //delete data.endDate
      delete data.endDate
    }
    //si no recupero los datos es POST si no es PUT
    handleForm(data, edicion === {} ? true : false);
  };

  const obtenerComunidades = (provinciaId) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${provinciaId}/comunidades`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  }

  const handleObtenerComunidades = (e, a) => {
    setLoading(true)
    //console.log('dddddddddddddddddddddddddddddddddddddddd')
    obtenerComunidades(e?.target?.value ? e.target.value : a)
      .then((response) => {
        setComunidades(response);
        setLoading(false)
      })
      .catch((e) => {
        // console.log(e)
        setLoading(false)
      });
  }

  return (
    <Container className="my-3 position-relative">
      <CustomSpinner loading={loading} animation={"border"} />
      <Form onSubmit={handleSubmit(onSubmit)} className="border rounded p-4" >
        <Form.Row>
          <small className="mb-3">
            Los campos con un <b>*</b> deben de ser rellenados.
          </small>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="fecha_inicio">
            <Form.Label>{"Fecha Inicio "} *</Form.Label>
            <Form.Control
              type="date"
              {...register("startDate", {
                required: "Este campo es obligatorio",
              })}
            />
            <small><ErrorMessage errors={errors} name="startDate" /></small>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="fecha_fin">
            <Form.Label>{"Fecha fin "} *</Form.Label>
            <Form.Control
              type="date"
              {...register("endDate", {
                validate: (endDate) => {
                  const startDate = getValues("startDate")
                  return !endDate ? true : endDate > startDate ? true : "La fecha de fin debe ser mayor a la fecha de inicio"
                }
              })}
            />
            <small><ErrorMessage errors={errors} name="endDate" /></small>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="provincia">
            <Form.Label>{"Provincia "} *</Form.Label>
            <Form.Control as="select" id='1' {...register("provinceId", { required: "Este campo es obligatorio" })} onChange={handleObtenerComunidades} custom >
              <option value=""> - Seleccione una provincia -</option>
              {provincias.items?.length ? provincias?.items.map(provincia => {
                return (
                  <option key={provincia.id} value={provincia.id}>
                    {`${provincia.name}`}
                  </option>
                );
              })
                :
                "No hay cursos en alta"
              }
            </Form.Control>
            <small><ErrorMessage errors={errors} name="provinceId" /></small>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} xs={12} md controlId="comunidad">
            <Form.Label>{"Comunidad "} *</Form.Label>
            <Form.Control as="select" id='2' {...register("communityId", { required: "Este campo es obligatorio" })} custom>
              <option value=""> - Seleccione una comunidad -</option>
              <option value="0">Sin comunidad asignada</option>
              {comunidades?.items?.length ? comunidades?.items.map(comunidad => {
                return (
                  <option key={`cc${comunidad.id}`} value={comunidad.id}>
                    {`${comunidad.name}`}
                  </option>
                );
              })
                :
                "No hay cursos en alta"
              }
            </Form.Control>
            <small><ErrorMessage errors={errors} name="communityId" /></small>
          </Form.Group>
        </Form.Row>
        <Button type='submit' className='button-outline-primary' variant="outline-primary">Guardar</Button>
      </Form>
    </Container>
  )
}
export default AddDestinoHermana